import { cacheTypes, deleteMethod, getMethod, postMethod } from "../../../store/api/CommonFunctions";

const BASE_URL = "api/WorkItemLinksAPI";
/**
 * 
 * @typedef {object} WorkItemLink
 * @property {number}  EntityID
 * @property {"Customer"|
 * "PreCustomer"|
 * "Event"|
 * "Install"|
 * "Repair"|
 * "Invoice"|
 * "FormalInvoice"|
 * "InterOfficeMessage_In"|
 * "InterOfficeMessage_Out"|
 * "Cheque"|
 * "ChequeFunction"|   
 * "BoM"|
 * "AccDocument"|
 * "Ticket"|
 * "Staff"|
 * "Agency"|
 * "Happycall"|
 * "GuaranteeCard"|
 * "SaleCampaign"|
 * "AccLevelOne"|
 * "AccLevelTwo"|
 * "AccLevelThree"|
 * "BankAccount"|
 * "Complaint"|
 * "Product"|
 * "Storage"|
 * "User"
 * } EntityType
 * @property {string} EntityNumber
 * @property {number} ID
 * @property {number} WorkItemID
 */

/**
 * 
 * @param {[WorkItemLink]} data 
 * @returns {{Data: [WorkItemLink]}}
 */
export const create = async (data) => {
    const result = await postMethod(`${BASE_URL}/Create`, data, "Create");
    return result;
}
/**
 * 
 * @param {number} id 
 * @returns {{Data:boolean}}
 */
export const deleteLink = async (id) => {
    const result = await deleteMethod(`${BASE_URL}/DeleteLink?id=${id}`, "DeleteLink");
    return result;
}
/**
 * 
 * @param {string} entityType 
 * @param {string} code 
 * @returns 
 */
export const getEntityTypes = async (entityType, code) => {
    const result = await getMethod(`${BASE_URL}/GetEntityTypes?entityType=${entityType??""}&code=${code??""}`, cacheTypes.NoCache, "GetEntityTypes");
    return result;
}